import { issueAttachmentsStore } from '@atlassian/jira-issue-attachments-store/src/index.tsx';
import { createContainer } from '@atlassian/react-sweet-state';

export const IssueAttachmentStoreContainer = createContainer(issueAttachmentsStore);
